import { call, all, put, takeEvery,debounce  } from 'redux-saga/effects';

import URLs from '../../../constants/urls';
import { apiPython as api } from '../../../service/api';

import { getSessionStorage } from '../../../utils/helpers';
import {
  getManageSMEAction,
  getSkillListSMEAction,
  saveManageSMEAction,
  setManageSMEErrorMessage,
  setManageSMELoader,
  setManageSMESuccessMessage,
  setSkillListSME,
  setUsersSME
} from '../../features/manageSME/manageSMESlice';

const mapUser = (user) => ({
  samId: user.SAMId ?? user.samId ?? '',
  firstName: user.FirstName ?? user.firstName ?? '',
  lastName: user.LastName ?? user.lastName ?? '',
  primaryEmail: user.PrimaryEmail ?? user.primaryEmail ?? '',
  managerName: user.ManagerName ?? user.managerName ?? '',
});

export function* getManageSMESaga(action) {
  yield put(setManageSMELoader(true));

  try {
    const response = yield api.get(`${URLs.GET_MANAGE_SME}?selectedSkillid=${action.payload}`);

    const data = response.data.data;
    const nonAccessUsers = (data.NonAccessUsers ?? data.nonAccessUsers ?? []).map(mapUser);
    const accessUsers = (data.AccessUsers ?? data.accessUsers ?? []).map(mapUser);
    yield put(setUsersSME({ nonAccessUsers, accessUsers }));

    yield put(setManageSMELoader(false));
  } catch (error) {
    yield put(setManageSMELoader(false));
    yield put(setManageSMEErrorMessage('Something went wrong'));
  }
}

export function* getSkillListSaga(action) {
  yield put(setManageSMELoader(true));

  try {
    const response = yield api.get(URLs.GET_TECHNICAL_QUESTION_BANK);

    yield put(setSkillListSME(response?.data.data.SkillArea ?? response?.data.data.skillArea ?? []));

    yield put(setManageSMELoader(false));
  } catch (error) {
    yield put(setManageSMELoader(false));
    yield put(setManageSMEErrorMessage('Something went wrong'));
  }
}

let isSavingInProgress = false;

export function* saveManageSMESaga(action) {
  if (isSavingInProgress) return; // Skip if already in progress
  
  isSavingInProgress = true;
  yield put(setManageSMELoader(true));

  try {
    const actualPayload = {
      ...action.payload,
      userSamId: getSessionStorage('USER_ID')
    };
    yield api.post(URLs.SAVE_MANAGE_SME, actualPayload);
    yield call(getManageSMESaga, { payload: action.payload.skillId });
    yield put(setManageSMESuccessMessage('Saved Successfully'));
  } catch (error) {
    yield put(setManageSMEErrorMessage('Something went wrong'));
  } finally {
    yield put(setManageSMELoader(false));
    isSavingInProgress = false; // Reset the flag
  }
}

export function* watchManageSME() {
  yield takeEvery(getManageSMEAction.type, getManageSMESaga);
  yield takeEvery(getSkillListSMEAction.type, getSkillListSaga);
  yield debounce(500, saveManageSMEAction.type, saveManageSMESaga); // Use debounce instead of takeEvery
}

export default function* manageSMESaga() {
  yield all([watchManageSME()]);
}
